import { ActionContext } from 'vuex';

import { getLocalState } from '@/common/utils/store';

import { TEventsCardParams } from '../../types/eventsCard';
import { EVENTS_CARD_VES_ACTIONS_NAME, EVENTS_CARD_VES_MUTATIONS_NAME } from './name';
import { TEventsCardState } from './types';

import links from '@/utils/links';
import request from '@/utils/request';

export async function getEventCard(context: ActionContext<TEventsCardState, unknown>, params: TEventsCardParams) {
  const settings = params.isSystemEvent
    ? { url: links.ves.events.getById, pathParams: ['id'] }
    : { url: links.ves.events.getEventCard };

  return request(
    context,
    {
      ...settings,
      mutate: getLocalState(EVENTS_CARD_VES_MUTATIONS_NAME.setEventCard),
      name: EVENTS_CARD_VES_ACTIONS_NAME.getEventCard,
    },
    { id: params.id },
  );
}
